import {
  HI_TRANSLATIONS,
  HI_PHRASE_TRANSLATIONS,
  LANGUAGE_STORAGE_KEY,
} from "./translations";

const normalizeLanguage = (language) => (language === "hi" ? "hi" : "en");
const preserveAsData = (text) =>
  /(?:https?:\/\/|www\.|@|^[\d\s₹$€£+\-.,:%/()]+$)/i.test(text.trim());

export function getStoredLanguage() {
  try {
    return normalizeLanguage(window.localStorage.getItem(LANGUAGE_STORAGE_KEY));
  } catch (_) {
    return "en";
  }
}

export function persistLanguage(language) {
  const normalized = normalizeLanguage(language);
  try {
    window.localStorage.setItem(LANGUAGE_STORAGE_KEY, normalized);
  } catch (_) {}
  return normalized;
}

function matchCaseInsensitive(map, value) {
  const direct = map[value];
  if (direct) return direct;
  const lower = value.toLocaleLowerCase("en-IN");
  const key = Object.keys(map).find(
    (item) => item.toLocaleLowerCase("en-IN") === lower,
  );
  return key ? map[key] : null;
}

const normaliseSentence = (text) => text.replace(/\s+/g, " ").trim();

function translateSentence(core) {
  if (preserveAsData(core)) return core;
  const sentence = normaliseSentence(core);
  return (
    matchCaseInsensitive(HI_TRANSLATIONS, sentence) ||
    matchCaseInsensitive(HI_PHRASE_TRANSLATIONS, sentence) ||
    core
  );
}

export function translateText(value, language = getStoredLanguage()) {
  const text = String(value ?? "");
  if (normalizeLanguage(language) !== "hi" || !text.trim()) return text;
  const leading = text.match(/^\s*/)?.[0] || "";
  const trailing = text.match(/\s*$/)?.[0] || "";
  const core = text.trim();
  return `${leading}${translateSentence(core)}${trailing}`;
}

export function setDocumentLanguage(language) {
  const normalized = persistLanguage(language);
  document.documentElement.lang = normalized === "hi" ? "hi-IN" : "en-IN";
  document.documentElement.dataset.language = normalized;
  return normalized;
}
